import { createClient } from 'contentful'

const client = createClient({
  // Space ID and access token for this space
  space: 'p7yh4e0gy36m',
  accessToken: 'XzDee6q7P7ZoEYZ6sHaftcMwBT-PkCK0W3zRWcXaJQs'
});

export default client